import { ThemeType } from '../types/command';

export interface ThemeTokens {
  bg: string;
  bgSecondary: string;
  bgTertiary: string;
  text: string;
  textSecondary: string;
  accent: string;
  accentHover: string;
  border: string;
  borderLight: string;
  success: string;
  error: string;
  info: string;
  muted: string;
  font: string;
  headerBg: string;
  cardBg: string;
  cardBgHover: string;
  shadow: string;
  shadowStrong: string;
  promptColor: string;
}

export const themeTokens: Record<ThemeType, ThemeTokens> = {
  cmd: {
    bg: '#0C0C0C',
    bgSecondary: '#141414',
    bgTertiary: '#1A1A1A',
    text: '#CCCCCC',
    textSecondary: '#999999',
    accent: '#808080',
    accentHover: '#4D4D4D',
    border: '#333333',
    borderLight: '#4D4D4D',
    success: '#16C60C',
    error: '#E74856',
    info: '#3B78FF',
    muted: '#767676',
    font: "'Cascadia Mono', 'Consolas', 'Lucida Console', monospace",
    headerBg: '#0C0C0C',
    cardBg: 'rgba(20, 20, 20, 0.7)',
    cardBgHover: 'rgba(30, 30, 30, 0.8)',
    shadow: 'rgba(0, 0, 0, 0.3)',
    shadowStrong: 'rgba(0, 0, 0, 0.6)',
    promptColor: '#CCCCCC',
  },
  powershell: {
    bg: '#012456',
    bgSecondary: '#01306E',
    bgTertiary: '#013A82',
    text: '#EEEDF0',
    textSecondary: '#B0B0C0',
    accent: '#FFFF00',
    accentHover: '#FFFFAA',
    border: '#0A3172',
    borderLight: '#1A4182',
    success: '#2CEC26',
    error: '#F14C4C',
    info: '#59A2FF',
    muted: '#8A8A8A',
    font: "'Cascadia Code PL', 'Cascadia Mono', 'Consolas', monospace",
    headerBg: '#012456',
    cardBg: 'rgba(1, 36, 86, 0.5)',
    cardBgHover: 'rgba(1, 48, 110, 0.6)',
    shadow: 'rgba(0, 0, 50, 0.3)',
    shadowStrong: 'rgba(0, 0, 50, 0.6)',
    promptColor: '#FFFF00',
  },
  ubuntu: {
    bg: '#300A24',
    bgSecondary: '#3D1232',
    bgTertiary: '#4A1A3F',
    text: '#FFFFFF',
    textSecondary: '#D0C0CA',
    accent: '#E95420',
    accentHover: '#F0693F',
    border: '#3F1B37',
    borderLight: '#5A2D4E',
    success: '#4CBB17',
    error: '#FF6B6B',
    info: '#7EBAE4',
    muted: '#A3A3A3',
    font: "'Ubuntu Mono', 'Droid Sans Mono', monospace",
    headerBg: '#300A24',
    cardBg: 'rgba(48, 10, 36, 0.5)',
    cardBgHover: 'rgba(61, 18, 50, 0.6)',
    shadow: 'rgba(30, 0, 20, 0.3)',
    shadowStrong: 'rgba(30, 0, 20, 0.6)',
    promptColor: '#4CBB17',
  },
};

// Helper to get token value for a theme
export const themed = (theme: ThemeType, property: keyof ThemeTokens): string => {
  return themeTokens[theme][property];
};
